import { render, staticRenderFns } from "./TemplateSelectionSentPanel.vue?vue&type=template&id=2775cead&scoped=true"
import script from "./TemplateSelectionSentPanel.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionSentPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionSentPanel.vue?vue&type=style&index=0&id=2775cead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775cead",
  null
  
)

export default component.exports